module.exports = __webpack_public_path__ + "static/example_year_photo_calendar-a22c2d93657d9365df3d20dfc88d5340.png";